/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAOffIcon20Solid = forwardRef('MediaAudioMicAOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.207 1.293a1 1 0 0 0-1.414 1.414L6.25 7.164V10a3.75 3.75 0 0 0 5.905 3.07l.894.893A5 5 0 0 1 5 10V9a1 1 0 0 0-2 0v1a7.001 7.001 0 0 0 6 6.93V18H6.5a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H11v-1.07a6.97 6.97 0 0 0 3.472-1.544l2.32 2.321a1 1 0 0 0 1.415-1.414l-15-15Z" }),
        React.createElement("path", { d: "m14.953 10.686 1.649 1.648c.258-.73.398-1.516.398-2.334V9a1 1 0 1 0-2 0v1c0 .233-.016.461-.047.686Z" }),
        React.createElement("path", { d: "m6.903 2.635 6.847 6.847V4.75a3.75 3.75 0 0 0-6.847-2.115Z" })));
});
